import React, {useState} from 'react';
import Modal from 'react-modal';

const POSHComplianceModal = ({isOpen, onRequestClose, onConfirm}) => {

  const closePoshCompilanceModal = () => {
    onRequestClose();
};

const handleConfirm = () => {
    // Call the onConfirm function passed as a prop
    onConfirm();
    // Close the modal
    closePoshCompilanceModal();
};


return (
 
      <div className="modal-content">
        <div className="modal-header border-bottom">
          <h5 className="modal-title font-weight-600 font-26 p-4">POSH Compliance Checklist (Calendar Year 2025)</h5>
        </div>
        <div className="modal-body py-3 p-4">
          <p>
            The Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013 (“POSH Act”) provides a comprehensive legal framework for the prevention, prohibition, and redressal of sexual harassment in the workplace. The Act is applicable to <strong>all workplaces in India</strong>—both organised and unorganised sectors—and mandates compliance on a <strong>calendar year basis</strong> (January to December).
          </p>
          <p><strong>Note:</strong> Legal compliance is the foundational step toward creating safe and inclusive workplaces, but not the endpoint. This checklist is intended to serve as an implementation tool to help your organisation assess its current compliance status, identify potential gaps, and develop an actionable roadmap to full and effective compliance with the POSH Act.</p>
          <p>We may ask for specific documentation (such as copies of policies, IC orders, training records, or proof of filing) to help you maintain an organised compliance archive. This is intended purely for internal review and continuity—particularly useful in the event of staff transitions, audits, or legal queries.</p>
          <p>This checklist incorporates the latest legal expectations and institutional best practices, including the official directives issued by the <strong>Office of the Additional Deputy Commissioner of Gurugram in December 2024</strong>, and reflects standards observed in recent regulatory and investor audits.</p>
         <div className='d-flex align-items-start'> 
          <div className='pe-4'>
             <p><strong>Data Use & Confidentiality:</strong> Any information shared through this checklist will be used <strong>solely to assess your organisation’s compliance with the POSH Act.</strong> It will <strong>not be shared with any external party</strong>, unless expressly authorised or required under applicable law. Please refrain from including any case details, or confidential complaint data in this checklist. This form is not meant for reporting or discussing individual cases.</p>
             <p><strong>By submitting this checklist, you confirm that you are authorised to do so on behalf of your organisation and that you have reviewed your responses for accuracy and completeness.</strong></p>
          </div>
            <img src='/images/guidlines-icon.svg' alt='POSH Compliance Checklist' className='img-fluid ' style={{ width: '200px', height: '200px' , objectFit: 'cover' }} />
         </div>
         
        </div>
        <div className="modal-footer border-top px-3 py-3">
          <button type="button" className="btn btn-primary btn-md" onClick={handleConfirm}>I Confirm</button>
        </div>
      </div>
    
);

}

export default POSHComplianceModal;
